import reducers from './patientReducers';

export default reducers;



// WEBPACK FOOTER //
// ./src/state/reducers/patient/index.js